import { IOfferHandlerResult } from '../../types';
import useBogo from '../basket-handlers-by-kind/useBogo';
import { Offer } from '../../../../services/exports/Interfaces';
import { OfferKindEnum } from '../../../../services/exports/Constants';
import useAmountOffByProducts from '../basket-handlers-by-kind/useAmountOffByProducts';
import useBogoHalfPrice from '../basket-handlers-by-kind/useBogoHalfPrice';
import useFreeItemByMinSpendValue from '../basket-handlers-by-kind/useFreeItemByMinSpendValue';
import usePercentageOffByMinSpendValue from '../basket-handlers-by-kind/usePercentageOffByMinSpendValue';
import usePercentageOffByProducts from '../basket-handlers-by-kind/usePercentageOffByProducts';
import useFreeItemByProducts from '../basket-handlers-by-kind/useFreeItemByProducts';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import useAmountOffByMinSpendValue from '../basket-handlers-by-kind/useAmountOffByMinSpendValue';

const useGetBasketOfferHandlerByKind = (): ((
  offer: Offer,
  items: CompleteBasketItem[],
) => ReturnType<IOfferHandlerResult>) => {
  const handlers: Record<OfferKindEnum, IOfferHandlerResult> = {
    [OfferKindEnum.Bogo]: useBogo(),
    [OfferKindEnum.BogoHalfPrice]: useBogoHalfPrice(),
    [OfferKindEnum.AmountOffByProducts]: useAmountOffByProducts(),
    [OfferKindEnum.AmountOffByMinSpendValue]: useAmountOffByMinSpendValue(),
    [OfferKindEnum.FreeItemByMinSpendValue]: useFreeItemByMinSpendValue(),
    [OfferKindEnum.FreeItemByProducts]: useFreeItemByProducts(),
    [OfferKindEnum.PercentageOffByMinSpendValue]: usePercentageOffByMinSpendValue(),
    [OfferKindEnum.PercentageOffByProducts]: usePercentageOffByProducts(),
  } as const;

  return (offer, items) => offer && handlers[offer.kind](offer, items);
};

export default useGetBasketOfferHandlerByKind;
